;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
// import SvgIcon from "@mui/material/SvgIcon"
// import svg from "./assets/FinalLogoIconUpdatesDec2024/LemonLeafAndDots.svg"

function ZestLifeIconLemonDotsInCircle() {
  return (
    <svg
      viewBox="0 0 512 512"
      // width="50"
      // height="50"
      style={{
        display: "block",
        flexShrink: 0,
      }}
      className="w-[50px] h-[50px] min-[700px]:w-[52px] min-[700px]:h-[52px]"
    >
      {/* Lemon leaf and dots icon - simplified version */}
      <defs>
        <style>{`
          .zlcls-1 { fill: #051e2d; }
          .zlcls-2 { fill: #def408; }
          .zlcls-3 { fill: #092c3c; }
          .zlcls-4 { fill: #e4ff3f; }
        `}</style>
      </defs>
      <g>
        <circle className="zlcls-4" cx="448.56" cy="187.85" r="20.38" />
        <circle className="zlcls-4" cx="461.1" cy="293.1" r="20.38" />
        <circle className="zlcls-4" cx="415.03" cy="388.9" r="20.38" />
        <circle className="zlcls-4" cx="331.76" cy="448.08" r="20.38" />
        <circle className="zlcls-4" cx="179.27" cy="63.92" r="20.38" />
        <circle className="zlcls-4" cx="284.52" cy="51.38" r="20.38" />
        <circle className="zlcls-4" cx="96.97" cy="131.2" r="20.38" />
        <circle className="zlcls-4" cx="63.44" cy="332.24" r="20.38" />
        <circle className="zlcls-4" cx="226.52" cy="460.62" r="20.38" />
        <circle className="zlcls-4" cx="130.72" cy="414.55" r="20.38" />
        <circle className="zlcls-4" cx="50.9" cy="227" r="20.38" />
      </g>
      <g>
        <path
          className="zlcls-4"
          d="m371.25,232.85c0,19.03-4.14,38.75-12.64,57.6-21.19,46.97-64.35,77.25-109.05,77.23-2.36,0-4.74-.07-7.1-.26-1.96-.11-3.86.81-4.96,2.45-9.29,13.96-25.1,20.02-37.58,14.38-12.5-5.64-18.41-21.48-14.09-37.69.51-1.92-.05-3.95-1.46-5.34-33.76-33.1-41.44-88.56-19.14-138.01,21.19-46.97,64.35-77.23,109.05-77.23,2.36,0,4.72.07,7.08.26,1.98.13,3.86-.79,4.96-2.43,9.3-13.98,25.1-20.04,37.58-14.4,12.5,5.64,18.41,21.48,14.09,37.69-.51,1.92.05,3.95,1.46,5.34,20.9,20.47,31.8,49.53,31.8,80.42Z"
        />
        <path
          className="zlcls-3"
          d="m399.24,137.36c-32.26,4.5-53.48-13.57-65.37-28.95,1.98-5.55,15.37-37.23,60.59-31.7,5.35.65,10.55,2.07,15.54,4.08,3.51,1.42,8.2,3.46,13.9,6.25,11.59,5.67,24.69,7.88,37.41,5.67.76-.14,1.55-.28,2.35-.45,0,0-10.18,37.52-64.42,45.09Z"
        />
        <path
          className="zlcls-1"
          d="m446.43,102.01c-7.28,9.41-21.61,21.31-48.66,25.09-9.06,1.26-17.71.5-25.75-2.27-2.15-.74-4.21-1.68-6.22-2.73-3.13-1.63-10.1-4.83-16.96-5.15,0,0,7.38-16,45.69-10.1,36.49,5.62,51.9-4.84,51.9-4.84Z"
        />
        <path
          className="zlcls-2"
          d="m363.61,292.71c-23.57,52.24-72.96,83.25-120.61,80.26,31.81-18.91,61.97-53.32,81.98-97.68,20.01-44.36,25.85-89.74,18.97-126.11,33.78,33.74,43.22,91.3,19.65,143.53Z"
        />
        <path
          className="zlcls-3"
          d="m209.74,397.32c-4.91,0-9.77-.99-14.35-3.06-16.56-7.47-25.05-27.08-20.91-47.42-35.16-36.52-42.97-95.6-19.27-148.15,23.71-52.55,73.13-85.86,123.82-83.6,12.51-16.57,32.83-23.17,49.39-15.71,16.56,7.47,25.05,27.07,20.91,47.42,35.17,36.52,42.99,95.61,19.29,148.16h0c-23.7,52.55-73.21,85.74-123.83,83.59-9.05,11.98-22.19,18.76-35.03,18.76Zm64.53-271.35c-44.7,0-87.87,30.27-109.06,77.24-22.3,49.45-14.61,104.91,19.14,138.01,1.41,1.38,1.97,3.42,1.46,5.33-4.32,16.21,1.6,32.07,14.08,37.7,12.49,5.63,28.29-.42,37.59-14.39,1.1-1.65,3-2.56,4.97-2.44,2.36.17,4.73.26,7.09.26,44.7,0,87.87-30.26,109.06-77.23h0c22.31-49.45,14.61-104.91-19.16-138.02-1.41-1.38-1.97-3.42-1.46-5.34,4.32-16.21-1.6-32.07-14.08-37.7-12.49-5.63-28.29.42-37.59,14.39-1.1,1.65-2.99,2.58-4.97,2.44-2.36-.17-4.72-.25-7.07-.25Z"
        />
      </g>
    </svg>
  )
}
export default ZestLifeIconLemonDotsInCircle
